import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from 'material-ui/Tabs';
import FontIcon from 'material-ui/FontIcon';
import { reduxForm } from 'redux-form';
import { base64Decode } from '../../../../actions/utilAction';
import SkillAquisition from './SkillAquisition/index';
import ManagePromptCode from './SetUp/promptCodes';
import MasteryCriteria from './SetUp/masteryCriteria';
import GeneralSettings from './SetUp/generalSettings';
import DefaultPhaseChangeLines from './SetUp/defaultPhaseChangeLines';
import Behaviors from './BehaviorReductiom/Behavior';
import Antecedents from './BehaviorReductiom/Antecedents';
import Consequences from './BehaviorReductiom/Consequences';
import Locations from './BehaviorReductiom/Locations';
import RawABCData from './BehaviorReductiom/RawABCData';
import PatientInfo from '../../patient_info';

const innerTabStyles = {
    default_tab: {
        height: '40px',
        fontSize: '14px',
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.60)',
        border: '1px solid #ddd',
    },
    active_tab: {
        height: '37px',
        color: 'rgba(0, 0, 0, 0.80)',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
    },
};

class DataCollectionSetUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientId: this.props.match.params.id ? base64Decode(this.props.match.params.id) : 0,
            activeTab: 0,
            activeTabValue: '0',
            innerActiveTab: '0',
        }
    }

    setActive(value) {
        this.setState({ activeTab: value, activeTabValue: value });
        this.setState({ innerActiveTab: '0' });
    }

    setInnerActive(value) {
        if (value === this.state.innerActiveTab) {
            return false;
        }
        this.setState({ innerActiveTab: value });
    }

    handleTabChange(value) {
        this.setState({ activeTabValue: value, activeTab: value });
    }

    renderSetupTabs() {
        let component = null;
        innerTabStyles.tab = [];
        innerTabStyles.tab[0] = innerTabStyles.default_tab;
        innerTabStyles.tab[1] = innerTabStyles.default_tab;
        innerTabStyles.tab[2] = innerTabStyles.default_tab;
        innerTabStyles.tab[3] = innerTabStyles.default_tab;
        innerTabStyles.tab[this.state.innerActiveTab] = innerTabStyles.active_tab;
        switch (this.state.innerActiveTab) {
            case '0':
                component = (<ManagePromptCode patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            case '1':
                component = (<MasteryCriteria patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            case '2':
                component = (<GeneralSettings patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            case '3':
                component = (<DefaultPhaseChangeLines patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            default:
                component = (<ManagePromptCode patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
        }
        return (
            <div className="readmin-panel">
                <div className="panel-body">
                    <div>
                        <Tabs className="custom_tabs secondary_tab">
                            <Tab className="customtab" style={innerTabStyles.tab[0]}
                                onClick={(e) => this.setInnerActive('0')}
                                value={0}
                                label={<font>Prompt Codes</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[1]}
                                onClick={(e) => this.setInnerActive('1')}
                                value={1}
                                label={<font>Mastery Criteria</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[2]}
                                onClick={(e) => this.setInnerActive('2')}
                                value={1}
                                label={<font>Interval Settings</font>}>
                            </Tab>                            
                            <Tab className="customtab" style={innerTabStyles.tab[3]}
                                onClick={(e) => this.setInnerActive('3')}
                                value={1}
                                label={<font>Default Phase Change Lines</font>}>
                            </Tab>
                        </Tabs>
                        {component}
                    </div>
                </div>
            </div>
        );
    }

    renderBehaviorReductionTabs() {
        let component = null;
        innerTabStyles.tab = [];
        innerTabStyles.tab[0] = innerTabStyles.default_tab;
        innerTabStyles.tab[1] = innerTabStyles.default_tab;
        innerTabStyles.tab[2] = innerTabStyles.default_tab;
        innerTabStyles.tab[3] = innerTabStyles.default_tab;
        innerTabStyles.tab[4] = innerTabStyles.default_tab;
        innerTabStyles.tab[this.state.innerActiveTab] = innerTabStyles.active_tab;
        switch (this.state.innerActiveTab) {
            case '0':
                component = (<Behaviors patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            case '1':
                component = (<Antecedents patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            case '2':
                component = (<Consequences patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            case '3':
                component = (<Locations patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            case '4':
                component = (<RawABCData patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
            default:
                component = (<Behaviors patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                break;
        }
        return (
            <div className="readmin-panel">
                <div className="panel-body">
                    <div>
                        <Tabs className="custom_tabs secondary_tab">
                            <Tab className="customtab" style={innerTabStyles.tab[0]}
                                onClick={(e) => this.setInnerActive('0')}
                                value={0}
                                label={<font>Behaviors</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[1]}
                                onClick={(e) => this.setInnerActive('1')}
                                value={1}
                                label={<font>Antecedents</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[2]}
                                onClick={(e) => this.setInnerActive('2')}
                                value={1}
                                label={<font>Consequences</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[3]}
                                onClick={(e) => this.setInnerActive('3')}
                                value={1}
                                label={<font>Locations</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[4]}
                                onClick={(e) => this.setInnerActive('4')}
                                value={1}
                                label={<font>Raw ABC Data</font>}>
                            </Tab>
                        </Tabs>
                        {component}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        var styles = {
            default_tab: {
                height: '50px',
                fontSize: '13px',
            },
            active_tab: {
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.10)',
                height: '48px',
                fontSize: '13px',
            },
        };
        styles.tab = [];
        styles.tab[0] = styles.default_tab;
        styles.tab[1] = styles.default_tab;
        styles.tab[2] = styles.default_tab;
        styles.tab[3] = styles.default_tab;
        styles.tab[4] = styles.default_tab;
        styles.tab[5] = styles.default_tab;
        styles.tab[this.state.activeTab] = styles.active_tab;
        styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
        return (
            <div>
                <h2 className="page_title">Data Collection SetUp</h2>
                <PatientInfo patientId={this.props.match.params.id ? base64Decode(this.props.match.params.id) : 0} />
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <Tabs className="custom_tabs" value={this.state.activeTabValue} >
                            <Tab
                                onClick={(e) => this.setActive('0')}
                                style={styles.tab[0]}
                                value="0"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Skill Acquisition</font>}>
                                {
                                    this.state.activeTabValue === '0' ?
                                       <SkillAquisition 
                                        patientId={this.props.match.params.id ? base64Decode(this.props.match.params.id) : 0}
                                       />
                                        : ''
                                }
                            </Tab>
                            <Tab
                                onClick={(e) => this.setActive('1')}
                                style={styles.tab[1]}
                                value="1"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Behavior Reduction</font>}>
                                {
                                    this.state.activeTabValue == '1' ?
                                        this.renderBehaviorReductionTabs()
                                        : ''
                                }
                            </Tab>
                            <Tab
                                onClick={(e) => this.setActive('2')}
                                style={styles.tab[2]}
                                value="2"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Setup</font>}>
                                {
                                    this.state.activeTabValue === '2' ?
                                        this.renderSetupTabs()
                                        : ''
                                }
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }
}

DataCollectionSetUp = reduxForm({
    form: 'DataCollectionSetUpForm',
    enableReinitialize: true,
})(DataCollectionSetUp);

function mapStateToProps(state) {
    return {
        //agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    }
}

export default connect(mapStateToProps, { })(DataCollectionSetUp);


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/index.js